import { useEffect, useRef, useState } from "react";
import Schedule from "./Schedule";
import PrimarySearchAppBar from "../../components/navBar/navBar";
import useEventData from "./useEventData";
import Preloader from "../../components/preloader/preloader";

const EventSingle = () => {
  const [eventsArrFromAPI] = useEventData();

  const [selectedEventObj, setSelectedEventObj] = useState(null);

  const [venue, setVenue] = useState(null);

  useEffect(() => {
    console.log(eventsArrFromAPI)
    if (eventsArrFromAPI.length) {
      const storedId = localStorage.getItem("id");
      if (storedId) {
        const parsedId = JSON.parse(storedId);

        const eventObj = eventsArrFromAPI.filter(
          (event) => event.id === parsedId
        );
        setSelectedEventObj(eventObj);
        console.log({eventObj});
      }
    }
  }, [eventsArrFromAPI]);

  const [hideOrExpand, setHideOrExpand] = useState("Read More");
  const [isReadMoreClicked, setIsReadMoreClicked] = useState(true);
  const event_Description = useRef();

  function expandDescription() {
    event_Description.current.classList.toggle("expand");

    if (isReadMoreClicked) {
      setHideOrExpand("Show Less");
      setIsReadMoreClicked(false);
    } else {
      setHideOrExpand("Read More");
      setIsReadMoreClicked(true);
    }
  }

  return (
    <>
      {/* <PrimarySearchAppBar /> */}
      {selectedEventObj && (
        <Schedule
          venueFromEventListAPI={selectedEventObj[0].venues}
          eventName={selectedEventObj[0].name}
        />
      )}
      <div className="wrapper ">
        {selectedEventObj ? (
          <div className="eventContent flexB">
            <div className="eventDetails">
              <div
                ref={event_Description}
                className="eventDescription"
                dangerouslySetInnerHTML={{
                  __html: selectedEventObj[0].summary,
                }}
              ></div>
              <button
                className="expand_or_hide_description_btn"
                onClick={expandDescription}
              >
                {hideOrExpand}
              </button>
            </div>
            <img
              className="event_Image"
              src={selectedEventObj[0].poster}
              alt={selectedEventObj[0].name}
            />
          </div>
        ) : (
          <Preloader />
        )}
      </div>
    </>
  );
};

export default EventSingle;
